const EntityStore = require("stores/abstract/EntityStore");
const router = require("services/router");
const axios = require("axios");
const assign = require("object-assign")
const {reportAndThrow} = require("helpers/errors");
const moment = require("moment");
const Promise = require("es6-promise");

class CartStore extends EntityStore {

	constructor(attributes = {}) {
		super(attributes);
	}

	submit(data = {}) {
		return axios.post(
			router.route("api.checkout.cart.submit"),
			assign({cart_id: this.attributes.guid}, data)
		).catch(reportAndThrow);
	}

	add(at, msg = null) {
		let payload = {
			cart_id: this.attributes.guid,
			bookable_id: this.attributes.bookable.id,
			at
		};

		if (msg) {
			payload.msg = msg;
		};

		return axios.post(
			router.route("api.checkout.cart.add"), payload
		).then(response => {
			assign(this.attributes, response.data);
			return response
		}).catch(reportAndThrow);
	}

	addMany(from, to, msg) {
		let payload = {
			cart_id: this.attributes.guid,
			bookable_id: this.attributes.bookable.id,
			from: from,
			to: to,
			msg: msg,
		};

		return axios.post(
			router.route("api.checkout.cart.add-many"), payload
		).then(response => {
			assign(this.attributes, response.data);
			return response
		}).catch(reportAndThrow);
	}

	sendMsg(msg) {
		let payload = {
			cart_id: this.attributes.guid,
			msg: msg,
			bookable_id: this.attributes.bookable.id,
		};

		return axios.post(
				router.route("api.checkout.cart.send-msg"), payload
			)
			.catch(reportAndThrow);
	}

	remove(booking_ids) {
		if (!(booking_ids instanceof Array)) {
			booking_ids = [booking_ids];
		}

		return axios.post(
			router.route("api.checkout.cart.remove"),
			{cart_id: this.attributes.guid, bookable_id: this.attributes.bookable.id, booking_ids},
		).then(response => {
			assign(this.attributes, response.data);
			return response
		}).catch(reportAndThrow);
	}

	removeAt(at) {
		return new Promise((resolve, reject) => {
			const booking = this.bookingAt(at);

			booking ?
				this.remove(booking.id).then(resolve).catch(reject) :
				reject();
		});
	}

	bookingAt(at) {
		return this.attributes.bookings.filter(booking => {
			return moment(booking.from).format("YYYY-MM-DD HH:mm") === moment(at).format("YYYY-MM-DD HH:mm");

		}) [0];
	}

	validateInstantBookingDistance() {
		return axios.post(
			router.route("api.checkout.cart.validate-instant-booking-distance"),
			{cart_id: this.attributes.guid, bookable_id: this.attributes.bookable.id}
		).then(response => response.data);
	}

	validateVoucher(voucher) {
		return axios.post(
			router.route("api.checkout.cart.validate-voucher"), {
				cart_id: this.attributes.guid,
				bookable_id: this.attributes.bookable.id,
				voucher_id: voucher
			}).then(response => response.data);
	}
}

module.exports = CartStore;



// WEBPACK FOOTER //
// ./resources/js/stores/abstract/CartStore.js